<template>
<div class="header__wrapper">
  <div class="header_content">
    <div class="app-market-logo">
      <i class="iconfont icon-logo1"></i>
      <i class="iconfont icon-wenzi"></i>
      <i class="iconfont icon-Line"></i>
      <i class="iconfont icon-yingyongshichang"></i>
    </div>
    <zcy-search></zcy-search>
  </div>
</div>
</template>

<script>
import Search from './search';
export default {
  components: {
    'zcy-search': Search
  }
};
</script>

<style lang="less" scoped>
@import '../../assets/css/common.less';
.header__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-width: @width-full;
  padding: 15px 0 30px 0;
  background: #fff;
  .header_content {
    width: @width-full;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .app-market-logo {
      height: 48px;
      line-height: 48px;
      display: flex;
      justify-content: flex-start;
      i {
        display: inline-block;
      }
      .icon-logo1 {
        color: #197AFF;
        font-size: 48px;
      }
      .icon-wenzi {
        // color: #24344E;
        font-size: 38px;
        margin-left: 10px;
      }
      .icon-Line {
        color: #DBDEE9;
        font-size: 36px;
      }
      .icon-yingyongshichang {
        color: #7F838F;
        font-size: 22px;
      }
      margin-right: 130px;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue